import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=212889c6&scoped=true&"
import script from "./BaseLoading.vue?vue&type=script&lang=js&"
export * from "./BaseLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212889c6",
  null
  
)

export default component.exports